<template>
  <modal
    ref="modal"
    contentClasses="px-5 py-4 bg-body assign-agent-modal"
    size="xl"
    bodyClasses="py-0"
  >
    <template v-slot>
      <p class="page-title font-weight-semibold">Assegna agente</p>

      <label class="font-weight-extrasmall">Cerca per nome</label>
      <div class="d-flex flex-column flex-md-row">
        <div class="px-0 my-md-auto">
          <div class="card">
            <div class="card-body px-3 py-2">
              <search-bar class="h-100" @search="onSearch" />
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary mr-sm-auto ml-md-auto mr-md-0 my-md-auto mt-3 mt-md-0"
          @click="onConfirm"
          :disabled="!selectedAgent"
        >
          Conferma
        </button>
      </div>
      <data-table
        :columns="columns"
        :values="agents"
        :loading="false"
        class="mt-5 data-table"
        @selected="onAgentSelected"
      >
        <content-loading
          :active.sync="getAgentsRequest.loading"
          :is-full-page="false"
          v-if="getAgentsRequest"
        />

        <template v-slot:column_agent="{ value }">{{
          value.fullname()
        }}</template>
        <template v-slot:no-results-label>
          <div class="bg-white p-5 d-flex">
            <p class="m-auto">Non è stato trovato nessun agente</p>
          </div>
        </template>
        <template v-slot:column_action="{ value }">
          <div class="radio text-right">
            <label>
              <input
                type="radio"
                name="o3"
                value
                :checked="isSelected(value)"
                @input="onAgentSelected(value)"
              />
              <span class="cr">
                <i class="cr-icon fa fa-circle"></i>
              </span>
            </label>
          </div>
        </template>
      </data-table>
      <div class="d-flex" v-if="getAgentsRequest.meta">
        <paginator
          :meta="getAgentsRequest.meta"
          :range="5"
          :loading="getAgentsRequest.loading"
          @change="onPageChange"
          class="mx-auto mt-4"
        >
          <template v-slot:left-arrow>
            <i class="fa fa-arrow-left"></i>
          </template>
          <template v-slot:right-arrow>
            <i class="fa fa-arrow-right"></i>
          </template>
        </paginator>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { User } from "models";
import UsersMixin from "mixins/http/UsersMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import Modal from "components/Modal.vue";
import ModelSelect from "components/ModelSelect.vue";
import DataTable from "@monade/vue-components/src/components/DataTable.vue";
import Loader from "vue-spinner/src/PulseLoader.vue";
import SearchBar from "components/SearchBar.vue";
import Paginator from "@monade/vue-components/src/components/Paginator.vue";

@Component({
  components: { Modal, ModelSelect, Loader, DataTable, SearchBar, Paginator },
})
export default class AssignAgent extends Mixins(UsersMixin) {
  static readonly getAgentsTag = "get_agents";
  static readonly assignAgentTag = "assign_agent";
  private selectedAgent?: User = null;
  private agents?: Array<User> = Array();
  private page = 1;
  private columns = [
    { name: "agent", label: "Agente" },
    { name: "action", label: "" },
  ];

  @RegisterHttp(AssignAgent.getAgentsTag) getAgentsRequest: RequestData;
  @RegisterHttp(AssignAgent.assignAgentTag) assignAgentRequest: RequestData;

  show() {
    this.loadAgents();
    const modal = this.$refs.modal as any;
    modal.show();
  }

  onPageChange(page) {
    this.page = page;
    this.loadAgents();
  }

  onAgentSelected(agent) {
    this.selectedAgent = agent;
  }

  onSearch(search) {
    this.page = 1;
    this.loadAgents({ term: search });
  }

  isSelected(agent) {
    return this.selectedAgent && agent.id === this.selectedAgent.id;
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  get params() {
    let data: any = {
      page: this.page,
      filter: {
        role: ["agent", "manager"],
      },
    };

    return data;
  }

  loadAgents(searchParams: any = {}) {
    let params = this.params;

    if (searchParams) {
      params.filter.term = searchParams.term;
    }

    this.getUsers(params, AssignAgent.getAgentsTag).then((resp) => {
      this.agents = resp;
    });
  }

  onConfirm() {
    this.hide();
    this.$emit("success", this.selectedAgent);
  }

  onCancel() {
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style lang="scss">
.assign-agent-modal {
  .data-table {
    min-height: 500px !important;
    overflow-y: auto;
    tr {
      cursor: pointer;
    }
  }
}
</style>
